import { render, staticRenderFns } from "./WorkflowConfigTab.vue?vue&type=template&id=488336a2"
import script from "./WorkflowConfigTab.vue?vue&type=script&lang=js"
export * from "./WorkflowConfigTab.vue?vue&type=script&lang=js"
import style0 from "./WorkflowConfigTab.vue?vue&type=style&index=0&id=488336a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports